import * as React from 'react';
import { colors } from '../../../index';

const IconBin = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "-0.155 -0.199 13.942 12.217",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.534 1.535H9.016V.542c0-.2-.16-.354-.359-.354-.019 0-.032.006-.038.013a.049.049 0 00-.026-.013H4.975a.348.348 0 00-.353.354v.993H3.098a.768.768 0 00-.775.78v1.277h.673v7.266c0 .438.333.773.768.773h6.104a.763.763 0 00.775-.773V3.592h.666V2.315c0-.438-.34-.78-.775-.78zM5.327.897h2.978v.638H5.327V.897zm4.605 9.96c0 .046-.02.065-.064.065H3.764c-.044 0-.064-.02-.064-.064V3.592h6.232v7.266zm.666-7.974H3.034v-.568c0-.045.02-.07.064-.07h7.436c.044 0 .064.025.064.07v.568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.106 4.424h1v5.866h-1zm-1.64 0h1v5.866h-1zm-1.639 0h1v5.866h-1z"
  }));
};

export default IconBin;